import * as React from "react";
import "./reconciliationModal.scss"
import DateUtils from "../../../../../utils/DateUtils";
import CurrencyHelper from "../../../../../helper/CurrencyHelper";
import {Option} from "ts-option";
import DataGrid from "../../../../../hiberUiKit/src/organisms/DataGrid/DataGrid";
import InvoicePaymentSummary from "../../../../../model/invoice/InvoicePaymentSummary";
import classNames = require("classnames");

interface IProps {
	invoicePaymentSummaries: InvoicePaymentSummary[];
	selectedSummaryId: Option<string>;
	onSummarySelect: (summary: InvoicePaymentSummary) => void;
}

export const InvoicePaymentSummariesTable: React.SFC<IProps> = (props) => {
	return (
		<div className="c-reconciliation-modal_matched-invoices-table-container">
			<div className="c-reconciliation-modal_matched-invoices-table-container_internal-container">
				<DataGrid>
					<thead>
					<tr className="c-reconciliation-modal_matched-invoices-table-container_table-header-row">
						<th>INVOICE #</th>
						<th>REF #</th>
						<th>INVOICE DATE</th>
						<th>AMOUNT</th>
					</tr>
					</thead>
					<tbody>
					{props.invoicePaymentSummaries.length === 0 && renderTableNoDataInfo}
					{props.invoicePaymentSummaries.map((summary, index) => {
						const classFromProps = classNames({
							"c-reconciliation-modal_matched-invoices-table-container_row": true,
							"selected": summary.id === props.selectedSummaryId.orNull
						});
						return (
							<tr className={classFromProps} onClick={() => props.onSummarySelect(summary)} key={index}>
								<td>{summary.invoiceNo.orNull}</td>
								<td>{summary.referenceNumber}</td>
								<td>{summary.invoiceDate.format(DateUtils.DAILY_PLAN_DATE_FORMAT)}</td>
								<td>{CurrencyHelper.toCurrency(summary.paymentAmount)}</td>
							</tr>
						);
					})}
					</tbody>
				</DataGrid>
			</div>
		</div>
	);
};

const renderTableNoDataInfo =
	<tr className="c-reconciliation-modal_matched-invoices-table-container_no-data-row">
		<td colSpan={4}>
			<div className="c-reconciliation-modal_matched-invoices-table-container_no-data-row_content">
				Matched invoice(s) will be shown here.
			</div>
		</td>
	</tr>;
